import React from "react";
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

const Liturgie = () => {
  return (
    <Container>
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Liturgie
        </Typography>
        
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ my: 3 }}>
          <Button 
            variant="contained" 
            color="primary"
            href="https://www.chiesacattolica.it/liturgia-del-giorno/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Messa del Giorno
          </Button>
          <Button 
            variant="contained" 
            color="primary"
            href="https://www.chiesacattolica.it/la-liturgia-delle-ore/?ora=lodi-mattutine"
            target="_blank"
            rel="noopener noreferrer"
          >
            Lodi Mattutine
          </Button>
          <Button 
            variant="contained" 
            color="primary"
            href="https://www.chiesacattolica.it/la-liturgia-delle-ore/?ora=vespri"
            target="_blank"
            rel="noopener noreferrer"
          >
            Vespri
          </Button>
        </Stack>

        <Box sx={{ my: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            Documenti Liturgici
          </Typography>
          <Box 
            sx={{ 
              width: '100%', 
              height: '600px',
              border: '1px solid #ddd',
              borderRadius: 1,
              overflow: 'hidden'
            }}
          >
            <iframe
              src="https://drive.google.com/embeddedfolderview?id=1JksXEwSPnTkqXK7v1RZt_brtzZEFcYjD#list"
              style={{ width: '100%', height: '100%', border: 'none' }}
              title="Documenti Liturgici"
            />
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default Liturgie;
